const de = {
  // Header
  'header.topbar': '+421 918 957 438',
  'header.about': 'Über uns',
  'header.brands': 'Marken',
  'header.contact': 'Kontakt',

  // Introduction
  'intro.title': 'Über uns',
  'intro.description': 'PXT ist ein führendes Unternehmen im Großhandel und Vertrieb von Unterhaltungselektronik. Mit über 20 Jahren Erfahrung auf dem Markt bieten wir eine breite Palette hochwertiger Produkte von den renommiertesten Marken der Branche.',
  'intro.mission.title': 'Unsere Mission',
  'intro.mission.description': 'Unsere Mission ist es, unseren Kunden die besten Produkte und Dienstleistungen anzubieten und dabei höchste Qualitätsstandards und Kundenzufriedenheit zu gewährleisten.',
  'intro.vision.title': 'Unsere Vision',
  'intro.vision.description': 'Wir streben danach, die erste Wahl im Vertrieb von Unterhaltungselektronik zu sein, anerkannt für unsere Exzellenz, Innovation und unser Engagement für unsere Kunden.',

  // Statistics
  'stats.years': 'Jahre Erfahrung',
  'stats.brands': 'Partnermarken',
  'stats.countries': 'Länder bedient',
  'stats.products': 'Produkte im Katalog',

  // Brands
  'brands.title': 'Unsere Marken',
  'brands.subtitle': 'Wir arbeiten mit den renommiertesten Marken der Unterhaltungselektronikbranche zusammen',

  // Worldwide Delivery
  'delivery.title': 'Weltweite Lieferung',
  'delivery.subtitle': 'Wir liefern unsere Produkte in über 30 Länder weltweit',
  'delivery.fast.title': 'Schnelle Lieferung',
  'delivery.fast.description': 'Effiziente Logistik, um sicherzustellen, dass Ihre Produkte pünktlich ankommen',
  'delivery.tracking.title': 'Sendungsverfolgung',
  'delivery.tracking.description': 'Verfolgen Sie Ihre Bestellung in Echtzeit vom Versand bis zur Lieferung',
  'delivery.support.title': 'Dedizierter Support',
  'delivery.support.description': 'Unser Team steht Ihnen bei jedem Schritt zur Verfügung',

  // Multi Language
  'multilang.title': 'Mehrsprachiger Service',
  'multilang.subtitle': 'Wir kommunizieren in Ihrer Sprache',
  'multilang.description': 'Unser Team ist bereit, Sie in mehreren Sprachen zu bedienen und eine klare und effektive Kommunikation mit Kunden aus der ganzen Welt zu gewährleisten.',
  'multilang.languages': 'Verfügbare Sprachen',
  'multilang.slovak': 'Slowakisch',
  'multilang.english': 'Englisch',
  'multilang.german': 'Deutsch',
  'multilang.czech': 'Tschechisch',
  'multilang.hungarian': 'Ungarisch',
  'multilang.polish': 'Polnisch',

  // Customer Care
  'care.title': 'Kundenbetreuung',
  'care.subtitle': 'Wir sind hier, um Ihnen zu helfen',
  'care.support.title': '24/7 Support',
  'care.support.description': 'Unser Team steht Ihnen rund um die Uhr zur Verfügung, um Ihre Fragen zu beantworten',
  'care.consultation.title': 'Fachberatung',
  'care.consultation.description': 'Experten bereit, Sie bei der Auswahl der besten Produkte zu unterstützen',
  'care.warranty.title': 'Erweiterte Garantie',
  'care.warranty.description': 'Alle unsere Produkte werden mit umfassender Garantie geliefert',
  'care.returns.title': 'Einfache Rückgabe',
  'care.returns.description': 'Einfacher und schneller Rückgabeprozess für Ihre Bequemlichkeit',

  // Footer
  'footer.about.title': 'Über PXT',
  'footer.about.description': 'Führendes Unternehmen im Großhandel und Vertrieb von Unterhaltungselektronik mit über 20 Jahren Markterfahrung.',
  'footer.links.title': 'Schnellzugriff',
  'footer.links.about': 'Über uns',
  'footer.links.brands': 'Marken',
  'footer.links.contact': 'Kontakt',
  'footer.links.privacy': 'Datenschutzrichtlinie',
  'footer.contact.title': 'Kontakt',
  'footer.contact.address': 'Adresse',
  'footer.contact.phone': 'Telefon',
  'footer.contact.email': 'E-Mail',
  'footer.social.title': 'Folgen Sie uns',
  'footer.rights': 'Alle Rechte vorbehalten.',
};

export default de;
